import {AddCustomerRequest} from './addCustomerRequest';

export class EditCustomerRequest extends AddCustomerRequest {
  force: boolean;
}
